import { http } from "../client";
export var getGenres = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.includeHidden, includeHidden = _c === void 0 ? false : _c;
    return http.api
        .get("genres", {
        params: {
            include_hidden: includeHidden ? 1 : undefined,
        },
    })
        .then(function (response) { return response.data.data; });
};
